import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import useStyles from "./useStyles";

import toast from "react-hot-toast";
import { ApiGetTodayPeriodo } from "../../api/periodos";
import { ApiGetAllUsers, ApiGetTotalAllUsers } from "../../api/usuarios";
import { socket } from "../../config/socket";
import { getData, saveOrUpdateArray } from "../../dblocal";
import ModalError from "./ModalError";
import SteperTickets from "./SteperTickets";
const IndexSpa = ({ panelControl, setPanelControl }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const [opened, { open, close }] = useDisclosure(false);
  const [user, setUser] = useState(null);
  const [periodo, setPeriodo] = useState(null);
  const [periodocode, setPeriodocode] = useState(null);

  const [usuariosnomina, setusuariosnomina] = useState([]);

  const [errorMessage, setErrorMessage] = useState([]);

  const { classes } = useStyles();
  const [active, setActive] = useState(0);

  useEffect(() => {
    // Conectar
    //socket.connect();
    if (!socket.connected) {
      socket.connect();
    }

    const handleNominaUsuarios = async (item) => {
      if (item.data?.source === "panel-control") {
        // Lógica específica para sincronizaciones desde matriz
        if (item.sala === "nominaUsuarios") {
          init();
          toast.success("Sincronización recibida desde matriz");
        }
      }
    };

    socket.emit("join:ticket", "nominaUsuarios");
    socket.on("ticket:updated", handleNominaUsuarios);
    // Escuchar un evento
    socket.on("reconnect", async (data) => {
      console.log("Server restarted, attempting to reconnect...");
      socket.emit("join:ticket", "nominaUsuarios");
      toast.error("Reconectando con el servidor");
    });

    socket.on("connect", () => {
      socket.emit("join:ticket", "nominaUsuarios");
    });

    return () => {
      socket.off("connect");
      socket.off("reconnect");
      socket.off("ticket:updated");
      socket.disconnect();
    };
  }, []);

  const nextStep = () =>
    setActive((current) => (current < 2 ? current + 1 : current));
  const prevStep = () =>
    setActive((current) => (current > 0 ? current - 1 : current));

  // Estado y efecto para el temporizador del modal de error
  const [errorTimer, setErrorTimer] = useState(null);

  const openErrorModal = () => {
    open();
    setErrorTimer(setTimeout(close, 1000));
  };

  useEffect(() => {
    function handleOnline() {
      setIsOnline(true);
    }

    function handleOffline() {
      setIsOnline(false);
    }

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const init = async () => {
    // console.log("iniciando online");
    let pageSize = 200;
    let auxdata = [];
    const res = await ApiGetTotalAllUsers();
    if (res.sms === "ok") {
      const totalPages = Math.ceil(res.data / pageSize);
      for (let i = 0; i <= totalPages; i++) {
        const { data, sms } = await ApiGetAllUsers({
          page: i + 1,
          pageSize: pageSize,
          estado: true,
        });
        if (sms === "ok") {
          auxdata = [...auxdata, ...data];
        }
      }
    }
    if (auxdata.length > 0) {
      await saveOrUpdateArray("usuarios", 1, auxdata);
    }
    initOffline();
  };

  const initOffline = async () => {
    // console.log("iniciando offline");
    let auxdata = [];
    const { success, data } = await getData("usuarios");
    if (!success) {
      return;
    }
    if (data.data.length > 0) {
      const verifica = await data.data.filter(
        (data) => parseInt(data.pre_usuario_id) === 2264
      );
      // console.log("verifica", verifica);
      auxdata = data.data;
    } else {
      auxdata = [];
    }
    if (auxdata.length > 0) {
      setusuariosnomina(auxdata);
    }
  };

  /* useEffect(() => {
    getIp();
    const timer = setInterval(() => {
      if (currentPage !== 1) {
        setCurrentPage(1);
        setPeriodo( localStorage.getItem("periodoInfo")
        ? JSON.parse(localStorage.getItem("periodoInfo"))
        : null);
        setUser(null);
        setActive(0);
      }
    }, 300000);
    return () => clearInterval(timer);
  }, [currentPage, active]); */

  const handleGetPeriodo = async () => {
    // console.log("iniciando online periodos");
    let auxdata = [];
    const response = await ApiGetTodayPeriodo();
    if (response.sms === "ok") {
      setPeriodocode(response.code);
      auxdata = [response.data];
    } else {
      auxdata = [];
      setPeriodocode(response.code);
    }
    if (auxdata.length > 0) {
      await saveOrUpdateArray("periodo", 1, auxdata);
    }
    handleGetPeriodoOffLine();
  };
  const handleGetPeriodoOffLine = async () => {
    // console.log("iniciando ofonline");
    let auxdata = [];
    const { message, data, success } = await getData("periodo");
    // console.log(message, data, success);
    if (!success) {
      return;
    }
    if (data.data.length > 0) {
      setPeriodocode("ok");
      auxdata = data.data[0];
    } else {
      auxdata = null;
    }
    setPeriodo(auxdata);
  };

  useEffect(() => {
    if (isOnline) {
      // console.log("online");
      init();
    } else {
      initOffline();
    }
  }, [isOnline]);

  useEffect(() => {
    // console.log(isOnline);
    if (isOnline) {
      handleGetPeriodo();
    } else {
      handleGetPeriodoOffLine();
    }
  }, [isOnline]);

  return (
    <div className="h-100 w-100  py-3 d-flex justify-content-center align-items-center">
      {periodo && periodocode === "ok" && usuariosnomina.length > 0 ? (
        <SteperTickets
          classes={classes}
          active={active}
          setActive={setActive}
          nextStep={nextStep}
          prevStep={prevStep}
          user={user}
          setUser={setUser}
          isOnline={isOnline}
          periodo={periodo}
          open={openErrorModal}
          close={close}
          nominausuarios={usuariosnomina}
          setErrorMessage={setErrorMessage}
          handleGetPeriodo={handleGetPeriodo}
          handleGetNomina={init}
        />
      ) : (
        <div className="w-100 d-flex justify-content-center align-items-center flex-column">
          <div>
            {isOnline
              ? periodocode === "notTime"
                ? "Aún no es una hora válida"
                : "Obteniendo información de los servidores"
              : "Obteniendo información local"}
          </div>
          <div>{isOnline ? "Online" : "Offline"}</div>
          <div className="p-2">
            <button
              className=""
              onClick={() => {
                window.location.reload();
                localStorage.removeItem("init");
              }}
            >
              Salir
            </button>
          </div>
        </div>
      )}
      <ModalError
        opened={opened}
        close={() => {
          clearTimeout(errorTimer);
          close();
        }}
        errorMessage={errorMessage}
        countdown={Math.floor(errorTimer / 1000)}
      />
    </div>
  );
};

export default IndexSpa;
